import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const articleImages: Record<number, { thumb: string; card: string }> = {
  1: {
    thumb: 'https://readdy.ai/api/search-image?query=warm%20family%20gathering%20young%20mother%20in%20law%20smiling%20with%20son%20in%20law%20modern%20living%20room%20soft%20natural%20light%20editorial%20photography%20cozy%20atmosphere%20beige%20and%20cream%20tones%20minimalist%20interior%20genuine%20emotional%20connection&width=600&height=400&seq=article-1-thumb&orientation=landscape',
    card: 'https://readdy.ai/api/search-image?query=warm%20family%20gathering%20young%20mother%20in%20law%20smiling%20with%20son%20in%20law%20modern%20living%20room%20soft%20natural%20light%20editorial%20photography%20cozy%20atmosphere%20beige%20and%20cream%20tones&width=600&height=400&seq=article-1-card&orientation=landscape',
  },
  2: {
    thumb: 'https://readdy.ai/api/search-image?query=two%20men%20having%20respectful%20conversation%20in%20bright%20modern%20apartment%20warm%20lighting%20professional%20but%20relaxed%20atmosphere%20beige%20and%20soft%20green%20tones%20editorial%20style%20clean%20composition&width=600&height=400&seq=article-2-thumb&orientation=landscape',
    card: 'https://readdy.ai/api/search-image?query=two%20men%20having%20respectful%20conversation%20in%20bright%20modern%20apartment%20warm%20lighting%20professional%20but%20relaxed%20atmosphere%20beige%20tones%20editorial%20style&width=600&height=400&seq=article-2-card&orientation=landscape',
  },
  3: {
    thumb: 'https://readdy.ai/api/search-image?query=three%20generations%20family%20sitting%20together%20in%20bright%20living%20room%20warm%20sunlight%20streaming%20through%20windows%20peaceful%20atmosphere%20grandmother%20daughter%20and%20grandchild%20smiling%20soft%20beige%20and%20cream%20color%20palette&width=600&height=400&seq=article-3-thumb&orientation=landscape',
    card: 'https://readdy.ai/api/search-image?query=three%20generations%20family%20sitting%20together%20in%20bright%20living%20room%20warm%20sunlight%20streaming%20through%20windows%20peaceful%20atmosphere%20soft%20beige%20and%20cream%20color%20palette&width=600&height=400&seq=article-3-card&orientation=landscape',
  },
  4: {
    thumb: 'https://readdy.ai/api/search-image?query=two%20women%20one%20older%20one%20younger%20having%20tea%20together%20in%20bright%20modern%20kitchen%20sunlight%20through%20window%20harmonious%20atmosphere%20soft%20warm%20tones%20editorial%20photography&width=600&height=400&seq=article-4-thumb&orientation=landscape',
    card: 'https://readdy.ai/api/search-image?query=two%20women%20one%20older%20one%20younger%20having%20tea%20together%20in%20bright%20modern%20kitchen%20sunlight%20through%20window%20harmonious%20atmosphere%20soft%20warm%20tones&width=600&height=400&seq=article-4-card&orientation=landscape',
  },
  5: {
    thumb: 'https://readdy.ai/api/search-image?query=person%20sitting%20peacefully%20by%20window%20journaling%20morning%20light%20warm%20atmosphere%20minimalist%20interior%20self%20care%20concept%20soft%20cream%20and%20sage%20green%20tones%20calm%20editorial%20style&width=600&height=400&seq=article-5-thumb&orientation=landscape',
    card: 'https://readdy.ai/api/search-image?query=person%20sitting%20peacefully%20by%20window%20journaling%20morning%20light%20warm%20atmosphere%20minimalist%20interior%20self%20care%20concept%20soft%20cream%20and%20sage%20green%20tones&width=600&height=400&seq=article-5-card&orientation=landscape',
  },
  6: {
    thumb: 'https://readdy.ai/api/search-image?query=family%20sitting%20in%20circle%20having%20open%20conversation%20in%20bright%20living%20room%20sunlight%20streaming%20through%20large%20windows%20warm%20atmosphere%20active%20listening%20editorial%20style%20cream%20and%20soft%20terracotta%20tones&width=600&height=400&seq=article-6-thumb&orientation=landscape',
    card: 'https://readdy.ai/api/search-image?query=family%20sitting%20in%20circle%20having%20open%20conversation%20in%20bright%20living%20room%20sunlight%20streaming%20warm%20atmosphere%20active%20listening%20cream%20and%20soft%20terracotta%20tones&width=600&height=400&seq=article-6-card&orientation=landscape',
  },
  7: {
    thumb: 'https://readdy.ai/api/search-image?query=elegant%20middle%20aged%20woman%20sitting%20by%20window%20thoughtful%20expression%20soft%20morning%20light%20modern%20apartment%20warm%20beige%20and%20cream%20tones%20editorial%20portrait%20photography%20intimate%20atmosphere&width=600&height=400&seq=article-7-thumb&orientation=landscape',
    card: 'https://readdy.ai/api/search-image?query=elegant%20middle%20aged%20woman%20sitting%20by%20window%20thoughtful%20expression%20soft%20morning%20light%20modern%20apartment%20warm%20beige%20tones%20editorial%20portrait%20photography&width=600&height=400&seq=article-7-card&orientation=landscape',
  },
  8: {
    thumb: 'https://readdy.ai/api/search-image?query=festive%20family%20dinner%20table%20with%20warm%20candlelight%20multiple%20generations%20enjoying%20meal%20together%20cozy%20dining%20room%20holiday%20atmosphere%20soft%20warm%20lighting%20cream%20and%20gold%20tones%20editorial%20photography&width=600&height=400&seq=article-8-thumb&orientation=landscape',
    card: 'https://readdy.ai/api/search-image?query=festive%20family%20dinner%20table%20with%20warm%20candlelight%20multiple%20generations%20enjoying%20meal%20together%20cozy%20dining%20room%20holiday%20atmosphere%20soft%20warm%20lighting%20cream%20tones&width=600&height=400&seq=article-8-card&orientation=landscape',
  },
};

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.featured);
  const recent = articles.filter((a) => !a.featured).slice(0, 4);

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            精选推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            最受欢迎的家庭关系深度好文
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 mb-12">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="sm:w-2/5 h-48 sm:h-auto relative overflow-hidden flex-shrink-0">
                <img
                  src={articleImages[article.id].thumb}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5 flex flex-col justify-center flex-1">
                <span className="text-xs text-accent-600 font-medium mb-2">
                  {article.categoryName}
                </span>
                <h3 className="text-base md:text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span>{article.author}</span>
                  <span>·</span>
                  <span>{article.date}</span>
                  <span>·</span>
                  <span>{article.readTime} 分钟阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div>
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-xl font-bold font-heading text-foreground-950">
              最新文章
            </h3>
            <Link
              to="/category/xiangchu-zhidao"
              className="text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1"
            >
              查看全部 <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {recent.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="h-40 overflow-hidden">
                  <img
                    src={articleImages[article.id].card}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4">
                  <span className="text-xs text-accent-600 font-medium">
                    {article.categoryName}
                  </span>
                  <h4 className="text-sm font-semibold text-foreground-950 mt-1 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h4>
                  <div className="flex items-center gap-2 text-xs text-foreground-500">
                    <span>{article.date}</span>
                    <span>·</span>
                    <span>{article.readTime} 分钟</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}